import {
  propertyManagerRolePermission,
  propertyOwnerRolePermission,
} from '../RMS/utils/permissions';

export const propertiesPermissions = [
  'Owner',
  'ManagedOwner',
  'FlipdishStaff',
  ...propertyManagerRolePermission,
  ...propertyOwnerRolePermission,
] as AppState['permissions'];
